import { Outlet } from 'react-router-dom';
import Nav from '../components/Nav';
import Header from '../components/Header';
import withNotLogged from '../hocs/withNotLogged';

const LayoutMain = () => {
    return (
        <>
            <Header />
            <Nav />
            <div id="content">
                <Outlet />
            </div>
        </>
    );
};

export default withNotLogged(LayoutMain);
